module.exports = __webpack_public_path__ + "static/media/scr_onboarding_02_a.74923541.png";